import ROUTES from "@consts/routes";
import i18n from "@/lang/i18n";

const routerView = {
  render(c) {
    return c("router-view");
  }
}
export default [
  {
    path: 'bookings',
    name: ROUTES.ADMIN.BOOKING_LIST,
    meta: {
      breadcrumb: i18n.tc('breadcrumbs.Booking'),
      activeKey: 'admin.booking.list'
    },
    component: routerView,
    children: [
      {
        path: '',
        name: ROUTES.ADMIN.BOOKING_LIST,
        meta: {
          activeKey: 'admin.booking.list'
        },
        component: () => import("@components/admin/bookings/ListBooking"),
      },
      {
        path: 'create',
        name: ROUTES.ADMIN.BOOKING_CREATE,
        meta: {breadcrumb: i18n.tc('breadcrumbs.Booking create'), activeKey: 'admin.booking.list'},
        component: () => import("@components/admin/bookings/BookingCreate"),
      },
      {
        path: ':id/edit',
        name: ROUTES.ADMIN.BOOKING_EDIT,
        meta: {breadcrumb: i18n.tc('breadcrumbs.Booking edit'), activeKey: 'admin.booking.list'},
        component: () => import("@components/admin/bookings/BookingEdit"),
      },
      {
        path: 'create_from/:id',
        name: ROUTES.ADMIN.BOOKING_COPY_CREATE,
        meta: {breadcrumb: i18n.tc('breadcrumbs.Booking create'), activeKey: 'admin.booking.list'},
        component: () => import("@components/admin/bookings/BookingCopyCreate"),
      },
      {
        path: 'history/:id',
        name: ROUTES.ADMIN.BOOKING_HISTORY_LIST,
        meta: {breadcrumb: i18n.tc('breadcrumbs.Booking history'), activeKey: 'admin.booking.list'},
        component: () => import("@components/admin/bookings/ListBookingHistory"),
      },
    ]
  },
];
